module.exports = __webpack_public_path__ + "img/link_send.c0df2458.png";